import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

/**
 * Returns the ordinal number (1st, 2nd, 3rd, etc.) without brackets
 * Wraps dayjs.localeData().ordinal() and strips the brackets from the result
 *
 * @param number - The number to get the ordinal for
 * @returns The ordinal representation without brackets
 */
export const getOrdinal = (number: number): string => {
  const ordinal = dayjs.localeData().ordinal(number);

  // Remove brackets [] from the result if they exist
  return ordinal.replace(/[[\]]/g, '');
};

export default getOrdinal;
